<template>
  <div class="group-input col-12 row q-mt-sm">
    <label for="type-os">Número da OS</label>
    <q-input
      class="col-12 q-mt-sm form-tabulacao"
      outlined
      dense
      color="red-9"
      use-input
      fill-input
      input-debounce="0"
      v-model="requestData.osNumber"
      mask="##########"
      placeholder="Digite aqui"
      bg-color="white"
      lazy-rules
      :rules="[(val) => !!val || 'Campo Obrigatório']"
    />
  </div>
  <div class="group-input col-12 row q-mt-sm">
    <label for="type-os">Tipo de OS</label>
    <q-select
      id="type-os"
      class="col-12 q-mt-sm form-tabulacao"
      outlined
      dense
      ref="typeOSRef"
      v-model="requestData.typeOS"
      color="red-9"
      use-input
      hide-selected
      placeholder="Selecione"
      fill-input
      input-debounce="0"
      @filter="getTypeOsByClassification"
      :options="listTypeOs"
      option-value="value"
      option-label="text"
      bg-color="white"
      lazy-rules
      :rules="[(val) => !!val || 'Campo Obrigatório']"
    />
  </div>
  <div
    class="group-input col-12 row q-mt-sm"
    v-if="numericalTypeOs !== SERVICO_CONCLUIDO_MDU"
  >
    <label for="type-os">Código de baixa</label>
    <q-select
      class="col-12 q-mt-sm form-tabulacao"
      outlined
      dense
      v-model="requestData.writeOffCode"
      color="red-9"
      use-input
      disable
      hide-selected
      fill-input
      input-debounce="0"
      :options="optionsItens.optionsWriteOffCode"
      option-value="value"
      option-label="text"
      bg-color="white"
      lazy-rules
      :rules="[(val) => !!val || 'Campo Obrigatório']"
    />
  </div>
  <MduFinishServiceForm
    :optionsStateEquipaments="optionsItens.optionsStates"
    :actionOptions="optionsItens.optionsActionOs"
    :listWriteOffCode="optionsItens.optionsWriteOffCode"
    :requestData="requestData"
    v-if="numericalTypeOs === SERVICO_CONCLUIDO_MDU"
  />
  <div
    class="group-input col-12 column q-mt-sm"
    v-if="numericalTypeOs === INSTALACAO_NAO_CONTEMPLA_PADRAO"
  >
    <RequiredLabel
      title="Informe qual é a situação que impede a instalação?"
      name="impedimento_instalacao"
    />
    <q-select
      class="col-12 q-mt-sm form-tabulacao"
      outlined
      dense
      v-model="requestData.impedimento_instalacao"
      name="impedimento_instalacao"
      color="red-9"
      use-input
      hide-selected
      placeholder="Selecione"
      emit-value
      fill-input
      @filter="filterImpediments"
      input-debounce="0"
      :options="listImpediments"
      bg-color="white"
      lazy-rules
      :rules="[(val) => !!val || 'Campo Obrigatório']"
    />
  </div>
  <div
    class="group-input col-12 row q-mt-md"
    v-if="isShownFieldById.includes(numericalTypeOs)"
  >
    <label for="observation">Observação</label>
    <div class="col-12 row flex justify-around">
      <q-input
        v-model="requestData.observation"
        class="col-12 q-mt-sm"
        bg-color="white"
        color="red-9"
        maxlength="120"
        outlined
        type="textarea"
        dense
        placeholder="Digite até 120 caracteres..."
        lazy-rules
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
  </div>
</template>

<script>
  import { filterListByText } from "@/helpers/filterHelper";
import {
  INSTALACAO_NAO_CONTEMPLA_PADRAO,
  SERVICO_CONCLUIDO_MDU,
} from "@/utils/constans/specialCodes";
import { computed, ref } from "vue";
import RequiredLabel from "../RequiredLabel.vue";
import MduFinishServiceForm from "./MduFinishServiceForm.vue";

  export default {
    name: "DefaultForm",
    components: {
      MduFinishServiceForm,
      SERVICO_CONCLUIDO_MDU,
      INSTALACAO_NAO_CONTEMPLA_PADRAO,
      RequiredLabel,
    },
    props: {
      requestData: Object,
      isShownFieldById: Array,
      typeOs: String,
      optionsItens: Object,
    },

    setup(props, { emit }) {
      const numericalTypeOs = computed(() => {
        return Number(props.typeOs);
      });

      const listTypeOs = ref(props.optionsItens.optionsTypeOS);
      const listImpediments = ref(
        props.optionsItens.optionsInstallationImpediments
      );

      function getTypeOsByClassification(val, update) {
        update(() => {
          listTypeOs.value = filterListByText(
            props.optionsItens.optionsTypeOS,
            val,
            "text"
          );
        });
      }

      const filterImpediments = (val, update) => {
        update(() => {
          listImpediments.value = filterListByText(
            props.optionsItens.optionsInstallationImpediments,
            val
          );
        });
      };

      return {
        numericalTypeOs,
        SERVICO_CONCLUIDO_MDU,
        INSTALACAO_NAO_CONTEMPLA_PADRAO,
        listTypeOs,
        listImpediments,
        getTypeOsByClassification,
        filterImpediments,
      };
    },
  };
</script>

<style scoped lang="scss">
  label {
    font-family: Roboto;
    font-style: normal;
  }
  .section-service {
    width: 100%;

    .panel-services {
      .group-input {
        label {
          font-weight: bold;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.4);
        }
      }
    }
  }
</style>
